import React from "react";
import {
    FaMoneyBillWave,
    FaHome,
    FaGraduationCap,
    FaRocket,
    FaGlassCheers,
    FaBolt
} from "react-icons/fa";

const PerksBenefits = () => {

    const perks = [
        {
            icon: <FaMoneyBillWave />,
            title: "Competitive Salary",
            desc: "Get rewarded fairly for your skills, expertise and contribution."
        },
        {
            icon: <FaHome />,
            title: "Remote Friendly",
            desc: "Work from anywhere with flexibility and a healthy work-life balance."
        },
        {
            icon: <FaGraduationCap />,
            title: "Learning Budget",
            desc: "Access courses, certifications and resources to keep growing."
        },
        {
            icon: <FaRocket />,
            title: "Career Growth",
            desc: "Fast-track opportunities and mentorship for ambitious people."
        },
        {
            icon: <FaGlassCheers />,
            title: "Team Events",
            desc: "Virtual and in-person celebrations, meetups and fun activities."
        },
        {
            icon: <FaBolt />,
            title: "Modern Projects",
            desc: "Build innovative products using the latest technologies."
        }
    ];

    return (
        <>
            <section className="pb-section">

                <div className="pb-glow glow-1"></div>
                <div className="pb-glow glow-2"></div>

                <div className="pb-container">

                    <div className="pb-header">

                        <span>PERKS & BENEFITS</span>

                        <h2>
                            More Than
                            <br />
                            Just A Job
                        </h2>

                        <p>
                            We believe great people deserve a great workplace.
                            Here are some of the benefits you'll enjoy at AppVerseLabs.
                        </p>

                    </div>

                    <div className="pb-grid">

                        {perks.map((item, index) => (

                            <div
                                key={index}
                                className="pb-card"
                            >

                                <div className="pb-icon">
                                    {item.icon}
                                </div>

                                <div className="pb-number">
                                    0{index + 1}
                                </div>

                                <h3>
                                    {item.title}
                                </h3>

                                <p>
                                    {item.desc}
                                </p>

                                <div className="pb-hover"></div>

                            </div>

                        ))}

                    </div>

                </div>

                <style>{`

                .pb-section{
                    position:relative;
                    padding:150px 24px;
                    background:#fafafa;
                    overflow:hidden;
                }

                .pb-container{
                    max-width:1300px;
                    margin:auto;
                    position:relative;
                    z-index:2;
                }

                .pb-header{
                    text-align:center;
                    margin-bottom:80px;
                }

                .pb-header span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;
                    margin-bottom:24px;
                }

                .pb-header h2{
                    font-size:clamp(35px,7vw,58px);
                    line-height:.95;
                    
                    color:#111;
                    text-align: center;
                    margin-bottom:20px;
                    font-family:'Syne',sans-serif;
                }

                .pb-header p{
                    max-width:700px;
                    margin:auto;
                    color:#666;
                    text-align: center;
                    font-size:18px;
                    line-height:1.9;
                }

                .pb-grid{
                    display:grid;
                    grid-template-columns:repeat(3,1fr);
                    gap:28px;
                }

                .pb-card{
                    position:relative;
                    padding:40px;
                    border-radius:32px;
                    overflow:hidden;
                    background:rgba(255,255,255,.85);
                    backdrop-filter:blur(20px);
                    border:1px solid rgba(232,33,42,.08);
                    transition:.45s ease;
                    box-shadow:
                    0 20px 50px rgba(0,0,0,.05);
                }

                .pb-card:hover{
                    transform:translateY(-12px);
                    border-color:#E8212A;
                    box-shadow:
                    0 30px 80px rgba(232,33,42,.12);
                }

                .pb-icon{
                    width:80px;
                    height:80px;
                    border-radius:24px;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    font-size:34px;
                    margin-bottom:25px;
                    color:#fff;
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    box-shadow:
                    0 20px 40px rgba(232,33,42,.25);
                }

                .pb-number{
                    position:absolute;
                    top:30px;
                    right:30px;
                    font-size:54px;
                    font-weight:800;
                    color:rgba(232,33,42,.12);
                    font-family:'Syne',sans-serif;
                }

                .pb-card h3{
                    font-size:30px;
                    margin-bottom:14px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                }

                .pb-card p{
                    color:#666;
                    line-height:1.9;
                    font-size:15px;
                }

                .pb-hover{
                    position:absolute;
                    width:240px;
                    height:240px;
                    border-radius:50%;
                    background:
                    radial-gradient(
                        circle,
                        rgba(232,33,42,.15),
                        transparent 70%
                    );
                    top:-120px;
                    right:-120px;
                    opacity:0;
                    transition:.4s;
                }

                .pb-card:hover .pb-hover{
                    opacity:1;
                }

                .pb-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.12;
                }

                .glow-1{
                    width:450px;
                    height:450px;
                    background:#E8212A;
                    top:-150px;
                    left:-150px;
                }

                .glow-2{
                    width:350px;
                    height:350px;
                    background:#FF4D4D;
                    right:-120px;
                    bottom:-120px;
                }

                @media(max-width:991px){
                    .pb-grid{
                        grid-template-columns:repeat(2,1fr);
                    }
                }

                @media(max-width:768px){

                    .pb-section{
                        padding:100px 18px;
                    }

                    .pb-grid{
                        grid-template-columns:1fr;
                    }

                    .pb-header h2{
                        letter-spacing:-2px;
                    }

                    .pb-card{
                        padding:30px;
                    }

                    .pb-card h3{
                        font-size:24px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default PerksBenefits;